import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import DMSHeader from "../../DMSHeader/DMSHeader";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import ScheduleAnnouncement from "./ScheduleAnnouncement";

const ScheduleAnnouncementMain = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    GridStack.init();
  }, []);
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t('schedule_announcement')}
          fileName="Create Announcement"
          showmenu={true}
          showdownload={false}
          showIconsForback={false}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <ScheduleAnnouncement />,
    },
  ];

  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ScheduleAnnouncementMain;